/**
 * Chat History Component
 * Container for displaying chat history sidebar with session list
 */

import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import { useSessionManagerContext } from '../../sessionManagement/SessionManagerContext';
import ResetChatButton from '../ResetChatButton/ResetChatButton';
import {
  EmptyMessage,
  ErrorMessage,
  HistoryContainer,
  HistoryHeader,
  HistoryHeaderText,
  HistoryListContainer,
} from './ChatHistory.styled';
import ChatHistoryItem from './ChatHistoryItem';
import ChatHistorySkeleton from './ChatHistorySkeleton';

/**
 * ChatHistory Component
 * Displays chat history sidebar with new chat button and session list
 * Gets configuration from OcFabWidgetOptions context
 */
const ChatHistory: React.FC = () => {
  const { historyLoadable } = useSessionManagerContext();
  const { chatHistoryHeaderText, newChatButtonText } = useOcFabWidgetOptions();

  const renderHistoryContent = () => {
    if (historyLoadable.status === 'error') {
      return <ErrorMessage>{historyLoadable.error?.message}</ErrorMessage>;
    }

    if (historyLoadable.status === 'not-started' || historyLoadable.status === 'loading') {
      return <ChatHistorySkeleton />;
    }

    if (historyLoadable.status === 'success') {
      const data = historyLoadable.data;

      if (!data || !data.length) {
        return <EmptyMessage>No chat history</EmptyMessage>;
      }

      return (
        <>
          {data.map((item, index) => (
            <ChatHistoryItem key={`${item.ChatSessionId}-${index}`} item={item} />
          ))}
        </>
      );
    }

    return null;
  };

  return (
    <HistoryContainer>
      <HistoryHeader>
        <ResetChatButton
          icon={faPenToSquare}
          text={newChatButtonText}
          className="new-chat-button"
        />
        <HistoryHeaderText>{chatHistoryHeaderText}</HistoryHeaderText>
      </HistoryHeader>

      <HistoryListContainer>
        {renderHistoryContent()}
      </HistoryListContainer>
    </HistoryContainer>
  );
};

export default ChatHistory;

